import { render } from "./Depositos.vue?vue&type=template&id=a6c71f86"
import script from "./Depositos.vue?vue&type=script&lang=js"
export * from "./Depositos.vue?vue&type=script&lang=js"

import "./Depositos.vue?vue&type=style&index=0&id=a6c71f86&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__